__turbopack_context__.v({
  "className": "fraunces_4a1796e5-module__KLaTzW__className",
});
